import "owl.carousel";

let carouselObserver;

function whenVisible(element, initialize) {
    const bounds = element.getBoundingClientRect();
    if (!('IntersectionObserver' in window) || bounds.top < window.innerHeight + 300) {
        initialize();
        return;
    }
    element.initializeCarousel = initialize;
    carouselObserver.observe(element);
}

function initOwlCarousels() {
    carouselObserver?.disconnect();
    if ('IntersectionObserver' in window) {
        carouselObserver = new IntersectionObserver(entries => {
            entries.filter(entry => entry.isIntersecting).forEach(entry => {
                carouselObserver.unobserve(entry.target);
                entry.target.initializeCarousel?.();
                delete entry.target.initializeCarousel;
            });
        }, {rootMargin: '300px'});
    }
    $(".category__carousel").each(function () {
        if ($(this).data("owl.carousel")) {
            return;
        }

        whenVisible(this, () => $(this).owlCarousel({
            loop: false,
            autoWidth: true,
            slideBy: 3,
            rtl: true,
            dots: false,
            navText: [
                '<span aria-label="' + "Previous" + '" class="icon-Chevron_right"></span>',
                '<span aria-label="' + "Next" + '" class="icon-Chevron_left"></span>',
            ],
            responsive: {
                0: {
                    nav: false,
                },
                540: {
                    nav: true,
                },
            },
        }));
    });

    $(".banner__carousel").each(function () {
        if ($(this).data("owl.carousel")) {
            return;
        }

        whenVisible(this, () => $(this).owlCarousel({
            loop: true,
            rtl: true,
            nav: true,
            dots: true,
            pagination: true,
            items: 1,
            margin: 16,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            autoplaySpeed: 800,
            smartSpeed: 800,
            lazyLoad: true,
            lazyLoadEager: 1,
            navText: [
                '<span aria-label="' + "Previous" + '" class="icon-Chevron_right"></span>',
                '<span aria-label="' + "Next" + '" class="icon-Chevron_left"></span>',
            ],
            responsive: {
                0: {
                    nav: true,
                    dots: true,
                    pagination: true,
                    items: 1,
                    margin: 16,
                },
            },
        }));
    });

    $(".special-offer__carousel").each(function () {
        if ($(this).data("owl.carousel")) {
            return;
        }

        const count = $(this).children().length || 1;
        const itemsFor = (max) => Math.max(1, Math.min(max, count));

        whenVisible(this, () => $(this).owlCarousel({
            loop: false,
            rtl: true,
            margin: 8,
            dots: false,
            nav: count > 2,
            slideBy: 1,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            freeDrag: false,
            navText: [
                '<span aria-label="' + "Previous" + '" class="icon-Chevron_right"></span>',
                '<span aria-label="' + "Next" + '" class="icon-Chevron_left"></span>',
            ],
            responsive: {
                0: {
                    items: itemsFor(2),
                    nav: false,
                    margin: 0,
                    stagePadding: count > 2 ? 24 : 0,
                },
                576: {
                    items: itemsFor(2),
                    nav: false,
                    margin: 0,
                    stagePadding: count > 2 ? 32 : 0,
                },
                768: {
                    items: itemsFor(3),
                    nav: count > 3,
                    margin: 0,
                    stagePadding: 0,
                },
                992: {
                    items: itemsFor(4),
                    nav: count > 4,
                    margin: 0,
                },
                1200: {
                    items: itemsFor(5),
                    nav: count > 5,
                    margin: 0,
                },
            },
        }));
    });

    $(".intro-section__carousel").each(function () {
        if ($(this).data("owl.carousel")) {
            return;
        }

        whenVisible(this, () => $(this).owlCarousel({
            loop: false,
            autoWidth: true,
            nav: true,
            slideBy: 3,
            margin: 15,
            rtl: true,
            dots: false,
            navText: [
                '<span aria-label="' + "Previous" + '" class="icon-Chevron_right"></span>',
                '<span aria-label="' + "Next" + '" class="icon-Chevron_left"></span>',
            ],
            responsive: {
                0: {
                    nav: false,
                    margin: 8,
                    slideBy: 2,
                },
                540: {
                    nav: false,
                    margin: 12,
                    slideBy: 2,
                },
                768: {
                    nav: true,
                    margin: 15,
                    slideBy: 3,
                },
                1360: {
                    nav: true,
                },
            },
        }));
    });
}

document.addEventListener("page:load", initOwlCarousels);
document.addEventListener('page:before-unload', () => {
    carouselObserver?.disconnect();
    $('.owl-carousel.owl-loaded').each(function () {
        $(this).data('owl.carousel')?.destroy();
    });
});
